import { render, staticRenderFns } from "./ScoreList2.vue?vue&type=template&id=5489414c&scoped=true&"
import script from "./ScoreList2.vue?vue&type=script&lang=js&"
export * from "./ScoreList2.vue?vue&type=script&lang=js&"
import style0 from "./ScoreList2.vue?vue&type=style&index=0&id=5489414c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5489414c",
  null
  
)

export default component.exports